import types from '../constants/types'

export const queryMutation = {
  [types.QUERY_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = true
    state[action.request]['didInvalidate'] = false
  },
  [types.QUERY_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['lastUpdated'] = (new Date()).getTime()
  },
  [types.QUERY_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = true
    // state[action.request]['data'] = action.data.data
  },
  [types.QUERY_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
    // state[action.request]['data'] = action.data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/query.js